module.exports = __webpack_public_path__ + "img/w2.061ceba8.jpg";